import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './validate.css';
import { io } from 'socket.io-client';
import jsPDF from "jspdf";
import "jspdf-autotable";
import bwipjs from 'bwip-js'; 
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import imgTable from '../images/right-validate.png';
import betmap from './betmap.json';
import axios from 'axios';
import { API_URL, SOCKET_URL } from './environment';

import { collectLoginClientInfo } from "../helpers/browser-info";

// import iconOk from './../images/ok-btn.svg';
// import iconClose from './../images/icon-close.svg';
// import iconReplay from './../images/icon-home.svg';
// import iconReceipt from './../images/receipt.svg';
// import iconReprint from './../images/reprint.svg';
// import iconRepeatBet from './../images/icon-repeat-bet.svg';

import homeIcon from '../images/icons/home-icon.svg';
import createIcon from '../images/icons/create-icon.svg';
import validateIcon from '../images/icons/validate-icon.svg';
import historyIcon from '../images/icons/history-icon.svg';
import shiftIcon from '../images/reprint.svg';



function Validate() {
  const navigate = useNavigate();
  // const [barcode, setBarcode] = useState(""); // Stores the barcode
  const [lastScanned, setLastScanned] = useState(""); // Stores the last scanned barcode
  const [ticketId, setTicketId] = useState('');
  const [agentId, setAgentId] = useState('');
  const [bettingShopId, setBettingShopId] = useState('');
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [popupData, setPopupData] = useState({});
  const [validationCode, setValidationCode] = useState('');
 
  // let buffer = ""; // Temporary buffer to hold scanned characters
  // let timeout = null; // Timeout to detect the end of scanning

  const socketRef = useRef(null); // Ref to persist the socket instance across renders
  const bufferRef = useRef(""); // Ref to store buffer value
  const timeoutRef = useRef(null); // Ref to store timeout ID
  const ticketIdRef = useRef(""); // Ref for immediate access to ticketId
  const agentIdRef = useRef(""); // Ref for immediate access to agentId
  const bettingShopIdRef = useRef(""); // Ref for immediate access to bettingShopId
  const popupDataRef = useRef(null); // Ref for immediate access to popupData

  const CORRECT_PIN = "4343";

  const [pinInput, setPinInput] = useState("");
  const [dotStatus, setDotStatus] = useState(["idle", "idle", "idle", "idle"]);

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
      setIsMenuOpen(!isMenuOpen);
  };
  
  useEffect(() => {
    const newDotStatus = dotStatus.map((_, i) =>
      i < pinInput.length ? "active" : "idle"
    );
    setDotStatus(newDotStatus);
  }, [pinInput]);
  
  const handleNumberClick = (num) => {
    if (pinInput.length >= 4) return;
    setPinInput((prev) => prev + num);
  };
  
  const handleClear = () => {
    setPinInput("");
    setDotStatus(["idle", "idle", "idle", "idle"]);
  };
  
  
  const animateDots = (outcome) => {
    setDotStatus(dotStatus.map(() => outcome));
  
    if (outcome === "wrong") {
      document.getElementById("pin").classList.add("shake");
      setTimeout(() => {
        document.getElementById("pin").classList.remove("shake");
      }, 600);
    }
  
    setTimeout(() => {
      setPinInput("");
      setDotStatus(["idle", "idle", "idle", "idle"]);
    }, 900);
  };



  useEffect(() => {
    document.body.classList.add('validate-active');
    const storedUser = JSON.parse(localStorage.getItem("sun_user"));
    const isCashier = storedUser && storedUser.role === 'CASHIER';
    if (isCashier) {
      setIsMenuOpen(true);
    }

    return () => {
      // Cleanup to remove the class when the component unmounts
      document.body.classList.remove('validate-active');
    };
  }, []);

  // Synchronize popupDataRef with popupData state
  useEffect(() => {
    popupDataRef.current = popupData;
  }, [popupData]);

  // Update the ref whenever ticketId changes
  useEffect(() => {
    ticketIdRef.current = ticketId;
    
  }, [ticketId]);

  useEffect(() => {
    agentIdRef.current = agentId;
  }, [agentId]);

  useEffect(() => {
    bettingShopIdRef.current = bettingShopId;
  }, [bettingShopId]);

  // let socketServer; // = io(SOCKET_URL);
  const closePopup = () => {
    handleClear();
    setPopupVisible(false);
    // setPopupData({});
  };

  

  const openPopupWithDetails = (ticketData) => {
    if (!ticketData || !ticketData.createdAt) {
      return;
    }
    const date = new Date(ticketData.createdAt);
    // console.log('ticketData.createdAt', ticketData.createdAt, date);
    const formattedTime = new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    }).format(date);

    setTicketId(ticketData.nanoId);
    // setAgentId(ticketData.agentId)
    ticketData.createdAtF = formattedTime;

    // Add jackpot data if it exists

    // No winnings 
    //     "megaJackpotId" : null,
    //     "miniJackpotId" : null,

    // Only mega j
    // Mini
    // Both mini j

    setPopupData(ticketData); // Set the popup data
    popupDataRef.current = ticketData;
    // setPopupVisible(true);
    setTicketId('');
  };

  // TODO:
  // The 'handleValidateClick' function makes the dependencies of useEffect Hook (at line 49)
  // change on every render. To fix this, wrap the 'handleValidateClick' definition into its
  // own useCallback() Hook.eslint(react-hooks/exhaustive-deps)
  // const handleValidateClick = () => {
  //   const ticketObj = {agentID: agentId, ticketID: ticketId.replace(/-/g,''), bettingShopID: bettingShopId};
  //   console.log('ticket obj to send', ticketObj);
  //   socketRef.current.emit('validate_ticket', ticketObj);
  // };


 
  const generatePDF = (type) => {
    const popupData = popupDataRef.current;
    if (!popupData) {
      return;
    }
    const rawTicketId = popupData.nanoId;
    const ticketId = formatStringWithHyphens(rawTicketId);
    // const hexDTicketId = this.hexToDecimal(rawTicketId);
    const spinNumber = popupData.spinNumber || '';
  
    const DAY_MINS = 60 * 24;
    const voidAfter = (parseInt(popupData.voidAfter) / DAY_MINS).toString();
    const validationCode = popupData.validationCode;

    // let tableRowsLenght = tableRows.length * 0.293;


    let tableRows = [];

    if (type === 'receipt') {
      tableRows = (
        popupData?.bets ? Object.entries(popupData.bets) : []
      )
        .filter(([key, value]) => value !== undefined) // Include only placed bets
        .map(([key, value]) => {
          let formKey;
          if (sideBetsMap[key]) {
            formKey = sideBetsMap[key];
          } else if (betmap[key]) {
            formKey = betmap[key].numbers?.join(',');
          } else {
            formKey = key;
          }
          const payout = popupData.payouts?.[key] !== undefined
            ? parseFloat(popupData.payouts[key]).toFixed()
            : null; // Include payout if available
          return [formKey, Math.round(value).toFixed(), payout];
        });
    } else if (type === 'ticket') {
      tableRows = (
        popupData?.bets ? Object.entries(popupData.bets) : []
      )
        .filter(([key, value]) => value !== undefined) // Include only placed bets
        .map(([key, value]) => {
          let formKey;
          if (sideBetsMap[key]) {
            formKey = sideBetsMap[key];
          } else {
            formKey = key;
          }
          return [formKey, parseFloat(value).toFixed()];
        });
    }

    if(popupData.megaJackpotId) {
      tableRows.unshift(['MEGA', '-', popupData.megaJackpotAmount])
      popupData.payoutAmount = parseInt(popupData.payoutAmount) || 0;
      popupData.payoutAmount += parseInt(popupData.megaJackpotAmount, 10);
    }

    if(popupData.miniJackpotId) {
      tableRows.unshift(['MINI', '-', popupData.miniJackpotAmount])
      popupData.payoutAmount = parseInt(popupData.payoutAmount) || 0;
      popupData.payoutAmount += parseInt(popupData.miniJackpotAmount, 10);
    }

    let tableRowsLength = tableRows.length * 0.293;


    let heightTable = 0;
    let height = 6.29; // Default height for the document
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'in',
      format: [3.12, tableRowsLength + 5.8] // Initial height, will recalculate later
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();


    // Set font and size
    doc.setFontSize(13);
    doc.setFont('helvetica', 'bold');
  
    // Text to center
    const text = "ROULETTE";
     // Get page width and text width
    const textWidth = doc.getTextWidth(text);

    // Calculate the x position to center the text
    const x = (pageWidth - textWidth) / 2;

    // Add text
    doc.text(text, x, 0.3);

    const text1 = popupData.bettingShopId?.name || '';
    const textWidth1 = doc.getTextWidth(text1);
    const x1 = (pageWidth - textWidth1) / 2;
  
    doc.setFontSize(12);  
    doc.setFont('helvetica', 'bold');  
    doc.setTextColor(0, 0, 0);
    doc.text(text1, x1, 0.6);  
  
    doc.setFontSize(14);  
    doc.setFont('helvetica', 'bold');  
    doc.setTextColor(0, 0, 0);
    doc.text("* * * * * * * * * * * * * * * * * * * * *", 0.25, 0.9);  
  
    const text2 = "TICKET";
    const textWidth2 = doc.getTextWidth(text2);
    doc.setFontSize(9);  
    doc.setFont('helvetica', 'bold');  
    doc.setTextColor(0, 0, 0);
    doc.text(text2, 0.25, 1.1);  
  
    doc.setFontSize(9);  
    doc.setFont('helvetica', 'bold');  
    doc.setTextColor(0, 0, 0);
    doc.text(`${ticketId}`, textWidth2 + 0.05, 1.1);  
  
    const text3 = "DRAW";
    const textWidth3 = doc.getTextWidth(text3);
    doc.setFontSize(9);  
    doc.setFont('helvetica', 'bold');  
    doc.setTextColor(0, 0, 0);
    doc.text(text3, 0.25, 1.4);  
   
    doc.setFontSize(9);  
    doc.setFont('helvetica', 'bold');  
    doc.setTextColor(0, 0, 0);
    doc.text(`#${spinNumber}`, 0.3 + textWidth3, 1.4); 


 
    const date = popupData.createdAtF;
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text(date, 1.3, 1.4); 


    doc.setFontSize(14);  
    doc.setFont('helvetica', 'bold');  
    doc.setTextColor(0, 0, 0);
    doc.text("* * * * * * * * * * * * * * * * * * * * *", 0.25, 1.75);  



    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text("Bet", 0.25, 1.9);

    const rightMargin = 0.25;
    const pageWidth2 = doc.internal.pageSize.width;

    const textX = pageWidth2 - rightMargin;

    doc.setFontSize(9);
    if (type === 'ticket') {
      doc.text("Amount", textX, 1.9, { align: 'right' });
    }

    if (type === 'receipt') {
      doc.text("Amount", 2.3, 1.9, { align: 'right' }); 
      doc.text("Payout", 2.8, 1.9, { align: 'right' });  
    }
   
  
    const tableColumns = ["Bet", "Amount"];


 
      const columnStyles = {
        0: { halign: 'left', fillColor: [255, 255, 255] }, 
      };

 
      if (type === 'receipt') {
        columnStyles[0] = { halign: 'left', cellWidth: 1.7, fillColor: [255, 255, 255] };
        columnStyles[1] = { halign: 'right',  fillColor: [255, 255, 255] };
        columnStyles[2] = { halign: 'right',  fillColor: [255, 255, 255] };
      }

      if (type === 'ticket') {
        columnStyles[1] = { halign: 'right', fillColor: [255, 255, 255] };
      }

 
      doc.autoTable({ 
        body: tableRows,
        startY: 2,
        tableWidth: 2.7,
        margin: { left: 0.2 },
        styles: {
          fontSize: 9,
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontStyle: 'bold', 
        },
        columnStyles, 
        didDrawPage: function (data) {
 
          heightTable = data.cursor.y - 1.9; 
          console.log("Table Height:", heightTable);
        },
      });

    doc.setFontSize(14);  
    doc.setFont('helvetica', 'bold');  
    doc.setTextColor(0, 0, 0);
    doc.text("* * * * * * * * * * * * * * * * * * * * *", 0.25, heightTable + 2.2);  
  
    doc.setFontSize(10);  
    doc.setFont('helvetica', 'bold');  
    doc.setTextColor(0, 0, 0);
    doc.text("TOTAL", 0.25, heightTable + 2.4); 
  


    let payoutAmountFormatted = null;
    if (popupData?.payoutAmount) {
      payoutAmountFormatted = Math.round(popupData.payoutAmount).toFixed();
    }
  
    // Define the right margin
   // Adjust this value as needed
  
    // Get page width

    if (type === 'ticket') {
      const totalBet = `${parseInt(popupData.betAmount).toFixed()}`;
  
      // Set the font properties
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(0, 0, 0);
    
      // Add text, aligned to the right
      doc.text(totalBet, textX, heightTable + 2.4, { align: 'right' });
    }

    if (type === 'receipt') {
      const totalBet = `${parseInt(popupData.betAmount).toFixed()}`;
      const totalPayouts = `${payoutAmountFormatted}`;
  
      // Set the font properties
      doc.setFontSize(11);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(0, 0, 0);
    
      // Add text, aligned to the right
      doc.text(totalBet, 2.4, heightTable + 2.4, { align: 'right' });
      doc.text(totalPayouts, 2.9, heightTable + 2.4, { align: 'right' });
    }

    
    
  
  
    // const totalBet = `$${this.state.betsTotal.toFixed(2)}`;
    
  
   
    doc.setFontSize(14);  
    doc.setFont('helvetica', 'bold');  
    doc.setTextColor(0, 0, 0);
    doc.text("* * * * * * * * * * * * * * * * * * * * *", 0.25, heightTable + 2.7);  
  
    const canvas = document.createElement('canvas');
    bwipjs.toCanvas(canvas, {
      bcid: 'code128',       // Barcode type
      text: rawTicketId,     // Text to encode
      scale: 5,              // Scale factor
      rotate: 'N',
      height: 1,            // Height of the barcode
      width: 3,
      includetext: false,     // Include text below the barcode
    });

    const barcodeImage = canvas.toDataURL();

  const BARCODE_OFFSET = 2.9;

  // Add the rotated barcode image to the PDF
  doc.addImage(barcodeImage, 'PNG', 0.05, heightTable + BARCODE_OFFSET, 3, 1);


  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');


  const textBefore = "Validation Code ";
  const number = validationCode;
  const textAfter = "";


  // Calculate the widths of the texts
  const textBeforeWidth = doc.getTextWidth(textBefore) + 0.04;
  const numberWidth = doc.getTextWidth(number);
  const totalTextWidth = textBeforeWidth + numberWidth + doc.getTextWidth(textAfter);

  const xStart = (pageWidth - totalTextWidth) / 2; // Center the text on the page

  const BOTTOM_TEXT_OFFSET = 4.2;

  // Draw the text parts
  doc.setTextColor(0, 0, 0); // Black
  doc.text(textBefore, xStart, heightTable + BOTTOM_TEXT_OFFSET);

  doc.setTextColor(0, 0, 0); // Red for the number
  doc.text(number, xStart + textBeforeWidth, heightTable + BOTTOM_TEXT_OFFSET);

  doc.setTextColor(0, 0, 0); // Back to black
  doc.text(textAfter, xStart + textBeforeWidth + numberWidth, heightTable + BOTTOM_TEXT_OFFSET);


  const textBefore2 = "Ticket Void after ";
  const number2 = voidAfter;
  const textAfter2 = "days";

  const textBeforeWidth2 = doc.getTextWidth(textBefore) + 0.04;
  const numberWidth2 = doc.getTextWidth(number2);
  const totalTextWidth2 = textBeforeWidth2 + numberWidth2 + doc.getTextWidth(textAfter);

  

  const xStart2 = xStart - 0.2;
  const BOTTOM_TEXT_OFFSET2 = 4.4;

  // Draw the text parts
  doc.setTextColor(0, 0, 0); // Black
  doc.text(textBefore2, xStart2, heightTable + BOTTOM_TEXT_OFFSET2);

  doc.setTextColor(0, 0, 0); // Red for the number
  doc.text(number2, xStart2 + totalTextWidth2, heightTable + BOTTOM_TEXT_OFFSET2);

  doc.setTextColor(0, 0, 0); // Back to black
  doc.text(textAfter2, xStart2 + totalTextWidth2 + numberWidth, heightTable + BOTTOM_TEXT_OFFSET2);





  doc.setFontSize(12);  
  doc.setFont('helvetica', 'bold'); 
  const text4 = "THANK YOU";
  const textWidth4 = doc.getTextWidth(text4);
  const x4 = (pageWidth - textWidth4) / 2;
  doc.setTextColor(0, 0, 0);
  const THANK_TEXT_OFFSET = 7.62;
  doc.text(text4, x4, heightTable + THANK_TEXT_OFFSET);



  doc.setFontSize(14);  
  doc.setFont('helvetica', 'bold');  
  doc.setTextColor(0, 0, 0);
  doc.text("* * * * * * * * * * * * * * * * * * * * *", 0.25, heightTable + 5.4);  





  // doc.save(`Ticket.pdf`);
  // return;
  // const pdfBlob = doc.output("blob");
  // const pdfURL = URL.createObjectURL(pdfBlob);
  // const pdfViewer = document.getElementById("pdfViewer");
  // pdfViewer.innerHTML = `<iframe src="${pdfURL}" width="100%" height="500px"></iframe>`;



      // Automatically open the print dialog
  doc.autoPrint();

  // Open the PDF directly in a new browser tab
  const pdfBlob = doc.output("blob");
  const blobURL = URL.createObjectURL(pdfBlob);
  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.top = "0";
  iframe.style.left = "0";
  iframe.style.width = "1px";
  iframe.style.height = "1px";
  iframe.style.border = "none";
  iframe.src = blobURL;

  iframe.onload = () => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print(); // Trigger print directly
  };

  document.body.appendChild(iframe);
  // Clean up the iframe after printing
  setTimeout(() => {
    document.body.removeChild(iframe);
  }, 2000);



  }



  const mainMenu = () => {

  };

  const handleValidateClick = useCallback(() => {
    console.log('before click');
    if (!(agentIdRef.current && ticketIdRef.current && bettingShopIdRef.current)) {
      return;
    }
    setValidationCode('');
    const ticketObj = {
      agentID: agentIdRef.current, // Use ref for latest agentId
      ticketID: ticketIdRef.current.replace(/-/g, ""), // Use ref for latest ticketId
      bettingShopID: bettingShopIdRef.current, // Use ref for latest bettingShopId
    };
    console.log('ticketObj sent', ticketObj);
    socketRef.current.emit("validate_ticket", ticketObj);
  }, []);

  const validateClickRef = useRef(handleValidateClick); // Ref for the handleValidateClick function

  const notify = (text = 'Text', type = 'success') => {
    toast[type](text, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 5000,
    });
  };

  // Keep the ref updated if the function changes
  useEffect(() => {
    validateClickRef.current = handleValidateClick;
  }, [handleValidateClick]);

  useEffect(() => {
    socketRef.current = io(SOCKET_URL);
    // socketServer.open();
    // this.socketServer.on('stage-change', (data) => {
    //   var gameData = JSON.parse(data) as GameData
    //   console.log('CONNECTION', data);
    //   this.setGameData(gameData)      
    // });
    socketRef.current.on('connect', (socket) => {
      console.log('connect');
      socketRef.current.emit('authentication', {username: 'sadmin', password: 'Admin776!'});
    });

    socketRef.current.on('authentication_response', (data) => {
      console.log('authentication_response', data);
      socketRef.current.emit('join_room', {room: 'agent'});
    });

    socketRef.current.on('unauthorized', (data) => {
      console.log('unauthorized', data);
    });

    socketRef.current.on('join_room_response', (data) => {
      console.log('join_room_response', data);
      const agentID = localStorage.getItem("sun_userId") || '';
      const bettingShopID = localStorage.getItem('sun_bettingShopId') || '';
      setAgentId(agentID);
      setBettingShopId(bettingShopID);
      // setAgentId(data.agentID);
      // setBettingShopId(data.bettingShopID);
    });


    // Listen for messages from the server
    socketRef.current.on('validate_ticket_response', async(message) => {
      console.log('validate_ticket_response', message);
       
      if (message && message.validity === 'EXPIRED') {
        setPopupData({});
        notify('Ticket is expired, cannot be redeemed', 'error');
        return;
      }

      if (message && ((message.validity === 'WAIT_FOR_GAME') || (message.validity === 'WAIT_FOR_ACCOUNTS'))) {
        setPopupData({});
        notify('Current Game In Progress. Please Try Later', 'warning');
        return;
      }
      if (message && message.success === false) {
        setPopupData({});
        notify('Incorrect Validation Code', 'error');
        return;
      }
      const ticketData = message.ticketObj || {};
      setTicketId(ticketData.nanoId);
      setValidationCode(ticketData.validationCode);
      openPopupWithDetails(ticketData);
      if (ticketData.isVoid) {
        notify('Ticket has been voided, cannot be redeemed', 'error');        
      }

      const userId = localStorage.getItem("sun_userId");

      // GET ip address
      const IP_SERVICE = 'https://api64.ipify.org/?format=json';
      const ipRes = await axios.get(IP_SERVICE);
      // console.log('ipRes', ipRes);
      const curIp = (ipRes && ipRes.data && ipRes.data.ip) || 0;

      const metadata = await collectLoginClientInfo({
        includeGeolocation: true,
        geolocationOptions: {
          enableHighAccuracy: false,
          timeout: 2000,
          maximumAge: 300000,
        },
      });

      const role = localStorage.getItem("sun_userRole");

      try {
        axios.post(`${API_URL}/logaction`, {
          action: 'validate_ticket',
          user: userId,
          role,
          gameId: ticketData.gameId,
          bettingShopId: bettingShopIdRef.current,
          ticketId: ticketData._id,
          metadata,
          ipAddress: curIp,
        });
      } catch (e) {
        console.log(e);
      }

    });

    socketRef.current.on('redeem_ticket_response', async(message) => {
      console.log('redeem_ticket_response', message);
      if (message.success === true) {
        // const ticketData = popupDataRef.current || {};
        // print redeem
        generatePDF('receipt');

        const userId = localStorage.getItem("sun_userId");

        // GET ip address
        const IP_SERVICE = 'https://api64.ipify.org/?format=json';
        const ipRes = await axios.get(IP_SERVICE);
        // console.log('ipRes', ipRes);
        const curIp = (ipRes && ipRes.data && ipRes.data.ip) || 0;

        const metadata = await collectLoginClientInfo({
          includeGeolocation: true,
          geolocationOptions: {
            enableHighAccuracy: false,
            timeout: 2000,
            maximumAge: 300000,
          },
        });

        const popupData = popupDataRef.current;
        const curTicketId = popupData._id;

        const role = localStorage.getItem("sun_userRole");

        try {
          axios.post(`${API_URL}/logaction`, {
            action: 'redeem_ticket',
            ticketId: curTicketId,
            user: userId,
            role,
            bettingShopId: bettingShopIdRef.current,
            metadata,
            ipAddress: curIp,
          });
        } catch (e) {
          console.log(e);
        }

        setValidationCode('');
        setTicketId('');
        setPopupData({});
        handleClear();
        notify('Ticket redeemed successfully', 'success');

      } else if (message.success === false) {
        handleClear();
        const errMsg = message.validity === 'INCORRECT_CODE' ? 'Incorrect Code' : 'Error. Please try again';
        notify(errMsg, 'error')
      }
    });


    const handleKeydown = (event) => {
      // Ignore non-character keys
      if (event.key === "Enter") {
        // Save the scanned barcode and clear the buffer
        // setBarcode(buffer);
        setLastScanned(bufferRef.current);
        setTicketId(bufferRef.current);
        ticketIdRef.current = bufferRef.current; // Update the ref immediately

        // auto scan immediately after getting a barcode from hardware
        handleValidateClick();


        bufferRef.current = "";
      } else if (event.key.length === 1) {
        // Append the key to the buffer
        bufferRef.current += event.key;

        // Clear the timeout and set a new one
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
          // Reset buffer if no activity after 300ms
          bufferRef.current = "";
        }, 300);
      }
    };

    // Add the event listener
    window.addEventListener("keydown", handleKeydown);

    return () => {
      // Cleanup the event listener on component unmount
      window.removeEventListener("keydown", handleKeydown);
    };
  }, []);

  const sideBetsMap = {
    'BLACK' : 'BLACK',
    'RED' : 'RED',
    'ODD' : 'ODD',
    'EVEN' : 'EVEN',
    'LOW' : '1-18',
    'HIGH' : '19-36',
    'DOZEN1' : '1-12',
    'DOZEN2' : '13-24',
    'DOZEN3' : '25-36',
    'COLUMN1' : 'Column 1',
    'COLUMN2' : 'Column 2',
    'COLUMN3' : 'Column 3',
    'ZEROSPIEL' : 'Zero Spiel',
    'ORPHELINS' : 'Orphelins',
    'VOISINS' : 'Voisins',
    'SNAKE' : 'Snake',
    'REDSPLIT_9_12' : 'Red Split 9,12',
    'REDSPLIT_16_19' : 'Red Split 16,19',
    'REDSPLIT_18_21' : 'Red Split 18,21',
    'REDSPLIT_27_30' : 'Red Split 27,30',
    'BLACKSPLIT_8_11' : 'Black Split 8,11',
    'BLACKSPLIT_10_11' : 'Black Split 10,11',
    'BLACKSPLIT_10_13' : 'Black Split 10,13',
    'BLACKSPLIT_17_20' : 'Black Split 17,20',
    'BLACKSPLIT_26_29' : 'Black Split 26,29',
    'BLACKSPLIT_28_29' : 'Black Split 28,29',
    'BLACKSPLIT_28_31' : 'Black Split 28,31',
    'ZEROSPIEL_0_3' : 'Zero Spiel 0,3',
    'ZEROSPIEL_12_15' : 'Zero Spiel 12,15',
    'ZEROSPIEL_32_35' : 'Zero Spiel 32,35',
    'ZEROSPIEL_26' : 'Zero Spiel 26',
    'TIERS_5_8' : 'Tiers 5,8',
    'TIERS_10_11' : 'Tiers 10,11',
    'TIERS_13_16' : 'Tiers 13,16',
    'TIERS_23_24' : 'Tiers 23,24',
    'TIERS_27_30' : 'Tiers 27,30',
    'TIERS_33_36' : 'Tiers 33,36',
    'ORPHELINS_6_9' : 'Orphelins 6,9',
    'ORPHELINS_14_17' : 'Orphelins 14,17',
    'ORPHELINS_17_20' : 'Orphelins 17,20',
    'ORPHELINS_31_34' : 'Orphelins 31,34',
    'ORPHELINS_1' : 'Orphelins 1',
    'VOISINS_25_26_28_29' : 'Voisins 25,26,28,29',
    'VOISINS_0_2_3' : 'Voisins 0,2,3',
    'VOISINS_4_7' : 'Voisins 4,7',
    'VOISINS_12_15' : 'Voisins 12,15',
    'VOISINS_18_21' : 'Voisins 18,21',
    'VOISINS_19_22' : 'Voisins 19,22',
    'VOISINS_32_35' : 'Voisins 32,35',
  };


  const handleInputChange = (event) => {
    setTicketId(event.target.value); // Update state with the input value
  };

  // const handleValCodeChange = (event) => {
  //   setValidationCode(event.target.value);
  // };

  const redeemTicket = () => {
    // setPopupVisible(true);
    if (popupData.isVoid) {
      notify('Ticket Already Voided', 'error');
      return;
    }
    const validCode = validationCode;

    const redeemedByUser = localStorage.getItem("sun_userId");
    const payload = {ticketID: popupData._id, agentID: redeemedByUser, validationCode: validCode}; // pinInput};
    console.log('redeem data', payload);
    socketRef.current.emit('redeem_ticket', payload);

    // generatePDF('receipt');
    // return;
  };

  const handleEnterValidationCode = () => {
    // const redeemedByUser = localStorage.getItem("sun_userId");
    // const payload = {ticketID: popupData._id, agentID: redeemedByUser, validationCode: pinInput};
    // console.log('redeem data', payload);
    // socketRef.current.emit('redeem_ticket', payload);
    // setPopupVisible(false);


    // if (pinInput.length === 4) {
    //   if (pinInput === CORRECT_PIN) {
    //     alert("✅ Correct PIN! Access granted.");
    //     animateDots("correct");
    //   } else {
    //     animateDots("wrong");
    //   }
    // }
  };

  const formatStringWithHyphens = (input) => {
    // Ensure the input is a string and has exactly 12 characters
    if (typeof input !== 'string' || input.length !== 12) {
        return '-';
    }
    // Insert a hyphen after every 4 characters
    return input.match(/.{1,4}/g).join('-');
  }

  // Function to format the raw value with hyphens for display
  const formatWithMask = (input) => {
    if (!input) {
      return '';
    }
    // Remove all non-alphanumeric characters
    const alphanumeric = input.replace(/[^a-zA-Z0-9]/g, '');

    // Insert hyphens after every 4 characters
    const masked = alphanumeric.match(/.{1,4}/g)?.join('-') || '';

    // Limit to 5 groups of 4 characters (24 characters + 5 hyphens = 29 total)
    return masked.slice(0, 29);
  };
 

  return (
    <>
        <div className="dashbord-wr"> 
        
            {/* Role Selection Buttons Debug */}

            <div className={`admin-page-menu ${isMenuOpen ? 'menu-open' : 'menu-closed'}`}>
          {/* Toggle button */}
          {/* <div className="admin-page-menu__toggle" onClick={toggleMenu}>
            <div className="admin-page-menu__toggle-icon">
              <img src={isMenuOpen ? iconClose : iconOk} alt={isMenuOpen ? "Close" : "Open"} />
            </div>
          </div> */}

          {/* Menu items - only show when menu is open */}
          {isMenuOpen && (
            <>
              <div className="admin-page-menu__item" onClick={() => navigate('/dashboard')}>
                <div className="admin-page-menu__item-icon">
                  <img src={homeIcon} alt="Home" />
                </div>
                <div className="admin-page-menu__item-title">
                  <span>Home</span>
                </div>
              </div>
              <div className="admin-page-menu__item" onClick={() => navigate('/admin')}>
                <div className="admin-page-menu__item-icon">
                  <img src={createIcon} alt="Create" />
                </div>
                <div className="admin-page-menu__item-title">
                  <span>Create</span>
                </div>
              </div>
              <div className="admin-page-menu__item" onClick={() => navigate('/validate')}>
                <div className="admin-page-menu__item-icon">
                  <img src={validateIcon} alt="Validate" />
                </div>
                <div className="admin-page-menu__item-title">
                  <span>Validate</span>
                </div>
              </div>
              <div className="admin-page-menu__item" onClick={() => navigate('/tickethistory')}>
                <div className="admin-page-menu__item-icon">
                  <img src={historyIcon} alt="History" />
                </div>
                <div className="admin-page-menu__item-title">
                  <span>History</span>
                </div>
              </div>
              <div className="admin-page-menu__item" onClick={() => navigate('/shift-management')}>
                <div className="admin-page-menu__item-icon">
                  <img src={shiftIcon} alt="Shift" />
                </div>
                <div className="admin-page-menu__item-title">
                  <span>Shift</span>
                </div>
              </div>
            </>
          )}
        </div>

        <div className="validate">
          <div className="validate-left">
            <div className="spin-border dashbord-border">
              <div className="spin-light spin-light-top">
                <div className="spin-light-container">
                  {Array.from({ length: 15 }).map((_, index) => (
                    <div className="spin-light-item" style={{ animationDelay: `${index * 0.2}s` }} key={index}></div>
                  ))}
                </div>
              </div>
              <div className="spin-number">
                <div className="spin-number__text">
                  <span className="spin-number__text-big">VALIDATE TICKET</span> 
                </div> 
              </div>
              <div className="spin-light spin-light-bottom">
                <div className="spin-light-container">
                  {Array.from({ length: 15 }).map((_, index) => (
                    <div className="spin-light-item" style={{ animationDelay: `${index * 0.2}s` }} key={index}></div>
                  ))}
                </div>
              </div>
            </div>

            <div className="validate-form">
              <input
                className="validate-form_input"
                placeholder="ENTER TICKET ID HERE"
                value={formatWithMask(ticketId)} // Bind the input value to state
                onChange={handleInputChange} // Update state on input change
              />
              <button className="validate-form_item btn-yellow" onClick={handleValidateClick}>Validate Ticket</button>
            </div>
            <div className="validate-scan">
              {/* <button className="validate-scan__btn btn-blue">USE BARCODE SCANNER</button> */}
              <div className="validate-scan__info">SCAN  A BARCODE WITH YOUR USB SCANNER</div>
            </div>
          </div>
          <div className="validate-right">
            <button className="return-menu btn-yellow" onClick={() => navigate('/dashboard')}>RETURN TO MAIN MENU</button>
            <div className="validate__table">
              <div className="spin-wrap-validate">
                <div className="spin-border mini-spin">
                  <div className="spin-light spin-light-top">
                    <div className="spin-light-container">
                      {Array.from({ length: 15 }).map((_, index) => (
                        <div className="spin-light-item" style={{ animationDelay: `${index * 0.2}s` }} key={index}></div>
                      ))}
                    </div>
                  </div>
                  <div className="spin-number">
                    <div className="spin-number__text">
                      <span className="spin-number__text-big">VALIDATE TICKET</span> 
                    </div> 
                  </div>
                  <div className="spin-light spin-light-bottom">
                    <div className="spin-light-container">
                      {Array.from({ length: 15 }).map((_, index) => (
                        <div className="spin-light-item" style={{ animationDelay: `${index * 0.2}s` }} key={index}></div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="ticket-table-validate">
                  <div className="ticket-table__title">
                    <div className="ticket-table__title-info">TICKET ID:</div>
                    <div className="ticket-table__title-id">{formatStringWithHyphens(popupData.nanoId)}</div>
                  </div>
                  {popupData.isVoid && <div className="ticket-table__block">
                    <div className="ticket-table__draw ticket-table__void-lbl">
                      VOIDED  
                    </div>
                  </div>}
                  <div className="ticket-table__block">
                    <div className="ticket-table__draw">
                      DRAW  
                      <span> : </span>
                      {popupData.spinNumber}
                    </div>
                    <div className="ticket-table__date">
                      {popupData.createdAtF}
                    </div>
                  </div>

                  <div className="ticket-table__table">
                    <div className="ticket-table__table-top">
                      <div className="ticket-table__table-top__item" 
                        style={{ width: "70%" }}
                      >BET</div>
                      <div className="ticket-table__table-top__item">AMOUNT</div>
                      <div className="ticket-table__table-top__item">PAYOUT</div>
                    </div>
                    <div className="ticket-table__table-middle">

                      {popupData.megaJackpotId && (
                          <div className="ticket-table__table-middle-row">
                            <div className="ticket-table__table-middle__col"
                              style={{ width: "80%", paddingRight: "5px" }}
                            >MEGA</div>
                            <div className="ticket-table__table-middle__col">-</div>
                            <div className="ticket-table__table-middle__col">{parseInt(popupData.megaJackpotAmount).toFixed()}</div>
                          </div>
                        )}

                      {popupData.miniJackpotId && (
                          <div className="ticket-table__table-middle-row">
                            <div className="ticket-table__table-middle__col"
                              style={{ width: "80%", paddingRight: "5px" }}
                            >MINI</div>
                            <div className="ticket-table__table-middle__col">-</div>
                            <div className="ticket-table__table-middle__col">{parseInt(popupData.miniJackpotAmount).toFixed()}</div>
                          </div>
                        )}

                      {popupData.bets &&
                          Object.entries(popupData.bets).map(([key, value]) => {
                            // Transform the key using sideBetsMap
                            // const formKey = sideBetsMap[key] || key;
                            let formKey;
                            if (sideBetsMap[key]) {
                              formKey = sideBetsMap[key];
                            } else if (betmap[key]) {
                              formKey = betmap[key].numbers?.join(',');
                            } else {
                              formKey = key;
                            }
                        
                            return (
                              <div key={key} className="ticket-table__table-middle-row">
                                <div className="ticket-table__table-middle__col"
                                  style={{ width: "80%", paddingRight: "5px" }}
                                >{formKey}</div>
                                <div className="ticket-table__table-middle__col">{parseInt(value).toFixed()}</div>
                                <div className="ticket-table__table-middle__col">{parseInt(popupData.payouts[key]).toFixed()}</div>
                              </div>
                              );
                          })}

                      {/* <div className="ticket-table__table-middle-row">
                        <div className="ticket-table__table-middle__col">BLACK</div>
                        <div className="ticket-table__table-middle__col">100.00</div>
                        <div className="ticket-table__table-middle__col">0.00</div>
                      </div>
                      <div className="ticket-table__table-middle-row">
                        <div className="ticket-table__table-middle__col">RED</div>
                        <div className="ticket-table__table-middle__col">200.00</div>
                        <div className="ticket-table__table-middle__col">0.00</div>
                      </div> */}
                    </div>
                    <div className="ticket-table__table-bottom">
                      <div className="ticket-table__table-bottom__item"
                        style={{ width: "73%" }}
                      >TOTAL</div>
                      <div className="ticket-table__table-bottom__item">{popupData.betAmount || 0}</div>
                      <div className="ticket-table__table-bottom__item">{(parseInt(popupData.payoutAmount || 0) + parseInt(popupData.megaJackpotAmount || 0) + parseInt(popupData.miniJackpotAmount || 0))}</div>
                    </div>
                  </div>

                  <div className="ticket-table__ticket-date">TICKET VOID AFTER 5 DAYS</div>
                  <div className="ticket-table__ticket-btn">
                    {/* <input
                      className="validate-redeem_input"
                      disabled={!parseInt(popupData.payoutAmount, 10)}
                      placeholder="VALIDATION CODE"
                      onChange={handleValCodeChange}
                      value={validationCode}
                    /> */}
                    <button className="btn-blue redeem-btn" 
                      disabled={!parseInt(popupData.payoutAmount, 10) || popupData.redeemed || popupData.isVoid}
                      onClick={()=>redeemTicket(popupData)}>REDEEM TICKET</button>
                    {/* <button className="btn-blue btn-ticket-table">CLOSE</button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

  

          {isPopupVisible && popupData && (<div id="pin"  style={{ display: CORRECT_PIN !== "" ? "flex" : "none" }}>
            <button className="btn-blue btn-close" onClick={closePopup}>X</button>
            <div className="dots">
              {dotStatus.map((status, idx) => (
                <div key={idx} className={`dot ${status}`}></div>
              ))}
            </div>

            <p>Validation Code</p>
            <div className="numbers">
              {/* Numbers 1-9 */}
              {Array.from({ length: 9 }, (_, i) => i + 1) // Generates [1, 2, 3, 4, 5, 6, 7, 8, 9]
                // .reverse() // Reverses it to [9, 8, 7, 6, 5, 4, 3, 2, 1]
                .map((num) => (
                  <div key={num} className="number" onClick={() => handleNumberClick(num)}>
                    {num}
                  </div>
              ))}

              {/* Extra Row: Clear, 0, Enter */}
              <div className="number special" onClick={handleClear}>Clear</div>
              <div className="number" onClick={() => handleNumberClick(0)}>0</div>
              <div className="number special" onClick={handleEnterValidationCode}>Enter</div>
            </div>
          </div>)}

        </div>

      </div>


      <ToastContainer />
    </>
  )
};

export default Validate;